<template>
  <Transition name="progress-fade">
    <div v-if="visible" class="micro-progress-bar" role="progressbar" :aria-valuenow="progress ?? 0" aria-valuemin="0" aria-valuemax="100">
      <div class="progress-track">
        <div 
          class="progress-fill" 
          :class="{ indeterminate: isIndeterminate }"
          :style="fillStyle"
        ></div>
      </div>
    </div>
  </Transition>
</template>

<script>
import { computed } from 'vue';

export default {
  name: 'MicroProgressBar',
  props: {
    /** Progress value 0-100. Pass null/undefined for indeterminate state. */
    progress: {
      type: Number,
      default: null,
    },
    /** Whether the bar is visible */
    visible: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const isIndeterminate = computed(() => props.progress === null || props.progress === undefined);
    
    const fillStyle = computed(() => {
      if (isIndeterminate.value) {
        return {}; // CSS animation handles indeterminate
      }
      const clamped = Math.max(0, Math.min(100, props.progress));
      return { width: `${clamped}%` };
    });
    
    return {
      isIndeterminate,
      fillStyle,
    };
  },
};
</script>

<style scoped>
.micro-progress-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  height: 3px;
  pointer-events: none;
}

.progress-track {
  width: 100%;
  height: 100%;
  background: var(--color-progress-track-inverse);
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(
    90deg,
    var(--color-accent-primary) 0%,
    var(--color-accent-selection) 50%,
    var(--color-accent-primary) 100%
  );
  transition: width 0.3s ease-out;
}

/* Indeterminate animation: sliding stripe */
.progress-fill.indeterminate {
  width: 30%;
  animation: indeterminate-slide 1.2s ease-in-out infinite;
}

@keyframes indeterminate-slide {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(400%);
  }
}

/* Fade in/out transition */
.progress-fade-enter-active,
.progress-fade-leave-active {
  transition: opacity 0.2s ease;
}

.progress-fade-enter-from,
.progress-fade-leave-to {
  opacity: 0;
}
</style>
